import { createSelector } from 'reselect';

export const getAuditUsers = createSelector(state => state.AuidtUsers, u =>u);
export const getAuditER = createSelector(state => state.AuidtER, u =>u);
export const getAuditConfig = createSelector(state => state.AuidtConfig, u =>u);
export const getAuditParams = createSelector(state => state.AuidtParams, u =>u);